import cls from 'classnames';

import Loader from '../../Loader';

import useStyles from './styles';

function LoadingRephrasedResults() {
  const classes = useStyles();

  return (
    <div className={cls(classes.input, classes.animation)}>
      <div className={classes.loader}>
        <Loader />
      </div>
    </div>
  );
}
export default LoadingRephrasedResults;
